var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGordonLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 522.812,
    height: 108.541,
    viewBox: "0 0 138.327 28.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff6c0c",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#feff16",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 5.479,
    y: 29.783,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "33.161px",
      lineHeight: 1.25,
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264583
    },
    transform: "translate(-7 -4.393)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.479,
    y: 29.783,
    style: {
      strokeWidth: 0.264583
    }
  }, "G   RDON")), /*#__PURE__*/React.createElement("path", {
    d: "m51.712 4.393-4.07 4.004a11.496 11.496 0 0 1 1.307.742zM48.949 9.14l-3.203 5.5 3.092-.677-5.422 7.252 2.82-.573-8.545 8.482a11.496 11.496 0 0 0 4.942 1.117 11.496 11.496 0 0 0 11.496-11.496 11.496 11.496 0 0 0-5.18-9.605ZM37.69 29.123a11.496 11.496 0 0 1-1.292-.72l-2.725 4.708zm-1.292-.72 3.229-5.577-3.153.746 5.49-7.286-2.926.575 8.603-8.464a11.496 11.496 0 0 0-5.01-1.149 11.496 11.496 0 0 0-11.495 11.496 11.496 11.496 0 0 0 5.262 9.659z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.60444,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-7 -4.393)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGordonLogo);
export default __webpack_public_path__ + "static/media/gordon_logo.a7972e3c31b54faea8c777bce7a959e4.svg";
export { ForwardRef as ReactComponent };